import { FC } from 'react';
import styles from './ActivityItem.module.css';
import { ActivityItemProps } from './ActivityItem.types';
import { Flex, Timestamp, Text, Tooltip, InlineUnsafe } from '@/_components';
import { ACTIVITY_LOG_COLORS } from '@/_constants/activity_logs';
import { ActivityItemIcon } from './_components/ActivityItemIcon';

export const ActivityItem: FC<ActivityItemProps> = ({ activityLog }) => {
  return (
    <Flex className={styles.activityItem} isColumn={true}>
      <ActivityItemIcon
        typeId={activityLog.type_id}
        color={
          ACTIVITY_LOG_COLORS[
            activityLog.type_id.toString() as keyof typeof ACTIVITY_LOG_COLORS
          ]
        }
        title={activityLog?.title}
      />
      <div>
        <Tooltip placement="top">
          <Tooltip.Trigger>
            <Flex isInline={true}>
              <Text type="tiny" fontWeight="medium" color="secondary">
                <Timestamp
                  timestamp={activityLog.created_at}
                  isFromNow={true}
                />
              </Text>
            </Flex>
          </Tooltip.Trigger>
          <Tooltip.Content>
            <Text type="tiny" fontWeight="medium" color="white">
              <Timestamp timestamp={activityLog.created_at} />
            </Text>
          </Tooltip.Content>
        </Tooltip>
      </div>
      <Flex isColumn={true}>
        <Text type="small" fontWeight="medium">
          {activityLog.title}
        </Text>
        {activityLog.description && (
          <Text type="small" color="secondary">
            <InlineUnsafe text={activityLog.description} />
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
